<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title>
                <v-switch
                    v-model="published"
                    :label="publishedText"
                />
            </v-card-title>
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                tag="div"
                                class="CustomPaletteEditColorWrapper"
                                name="color1"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <div class="CustomPaletteEditInput">
                                    <v-text-field
                                        label="Color 1"
                                        name="color1"
                                        id="color1"
                                        v-model="color1"
                                        outlined
                                        :error-messages="errors[0]"
                                    />
                                </div>
                                <div class="CustomPaletteEditSwatchWrapper">
                                    <div
                                        class="CustomPaletteEditSwatch"
                                        :style="'background-color:' + color1"
                                    />
                                </div>
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                tag="div"
                                class="CustomPaletteEditColorWrapper"
                                name="color2"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <div class="CustomPaletteEditInput">
                                    <v-text-field
                                        label="Color 2"
                                        name="color2"
                                        id="color2"
                                        v-model="color2"
                                        outlined
                                        :error-messages="errors[0]"
                                    />
                                </div>
                                <div class="CustomPaletteEditSwatchWrapper">
                                    <div
                                        class="CustomPaletteEditSwatch"
                                        :style="'background-color:' + color2"
                                    />
                                </div>
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                tag="div"
                                class="CustomPaletteEditColorWrapper"
                                name="color3"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <div class="CustomPaletteEditInput">
                                    <v-text-field
                                        label="Color 3"
                                        name="color3"
                                        id="color3"
                                        v-model="color3"
                                        outlined
                                        :error-messages="errors[0]"
                                    />
                                </div>
                                <div class="CustomPaletteEditSwatchWrapper">
                                    <div
                                        class="CustomPaletteEditSwatch"
                                        :style="'background-color:' + color3"
                                    />
                                </div>
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="order"
                                rules="integer"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Order"
                                    name="order"
                                    id="order"
                                    v-model="order"
                                    outlined
                                    :error-messages="errors[0]"
                                    type="number"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="paletteId"
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid"
                >
                    Delete Color Scheme
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import store from '../../../../store/store';

export default {
    computed: {
        name: {
            get: function() {
                return store.state.paletteEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        order: {
            get: function() {
                return store.state.paletteEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        published: {
            get: function() {
                return store.state.paletteEditor.published;
            },
            set: function(value) {
                this.setPublished(value);
            }
        },

        color1: {
            get: function() {
                return store.state.paletteEditor.color1;
            },
            set: function(value) {
                this.setColor1(value);
            }
        },

        color2: {
            get: function() {
                return store.state.paletteEditor.color2;
            },
            set: function(value) {
                this.setColor2(value);
            }
        },

        color3: {
            get: function() {
                return store.state.paletteEditor.color3;
            },
            set: function(value) {
                this.setColor3(value);
            }
        },

        ...mapState('paletteEditor', ['paletteId']),

        ...mapGetters({
            publishedText: 'paletteEditor/publishedText'
        })
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'paletteEditor/getData',
            saveData: 'paletteEditor/saveData'
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle',
            setId: 'paletteEditor/setPaletteId',
            setName: 'paletteEditor/setName',
            setOrder: 'paletteEditor/setOrder',
            setPublished: 'paletteEditor/setPublished',
            setColor1: 'paletteEditor/setColor1',
            setColor2: 'paletteEditor/setColor2',
            setColor3: 'paletteEditor/setColor3',
            toggleDeleteModal: 'paletteEditor/toggleDeleteModal',
        }),

        save() {
            this.saveData();
        }
    }
};
</script>
<style lang="scss">
.CustomPaletteEditColorWrapper {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.CustomPaletteEditSwatchWrapper {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
}

.CustomPaletteEditSwatch {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    box-shadow: 2px 2px 4px rgba(black, 0.2);
    margin-left: 12px;
}

.CustomPaletteEditInput {
    flex: 1 1 80%;
    width: 80%;
}
</style>
